<template>
  <div class="body_center_right_article">
    <div class="body_center_right_article_top">
      <div class="body_center_right_article_top_img"><img :src="member.avatar" /></div>
      <div class="body_center_right_article_top_title">邦人NAVI中国版トピックス</div>
      <div class="body_center_right_article_top_msg">hojinnavi special news</div>
    </div>
    <div class="body_center_right_article_box">
      <div class="body_center_right_article_box_item on_click" @click="onCountryFun()">{{areaData.name}}<img src="../../assets/imgs/select_white.png" /></div>
      <div class="body_center_right_article_box_item">{{time}}</div>
      <div class="body_center_right_article_box_item" @click="wechatVisible= true">微信公众号</div>
      <div class="body_center_right_article_box_area" v-if="countryState">
        <div v-for="(item,index) in areaList" @click="countryFun(item)" class="pointer" >{{item.name}}</div>
      </div>
    </div>
    <div class="body_center_right_article_content" v-loading="areaLoading">
      <div class="body_center_right_article_content_item" v-for="(item,index) in articlesList" :key="index" @click="toArticleFun(item)">
        <img :src="item.images[0]" />
        <div class="title">{{item.title}}</div>
        <div class="time">{{timeToStr(item.createdDate)}}</div>
        <div class="icon">{{index+1}}</div>
      </div>
      <div class="body_center_right_article_content_other">
        <div class="title" @click="nextPageFun()">もっと見る<div class="other_icon"><img src="@/assets/imgs/select_right.png" /></div></div>
      </div>
    </div>
    <el-dialog title="微信公众号" width="350px" center :visible.sync="wechatVisible">
      <div class="wechat"><img src="@/assets/imgs/wechat_mark.png"></div>
    </el-dialog>
  </div>
</template>

<script>
import * as json from '@/assets/js/json'
import { timeToStr,getDate } from '@/assets/js/util'
import "@/assets/css/right.css"
export default {
  components: {
    },
    data () {
      return{
        countryState : false,
        areaList: [],
        articlesList: [],
        areaData: {
          name:'中国',
          id: '1'
        },
        member: {},
        page: 1,
        areaLoading: true,
        time: null,
        wechatVisible: false
      }
    },
    created () {
      this.time = getDate()
      this.initData()
      // this.fetch()
    },
    methods: {
      initData(){
        json.post('/api/member/index/area/list').then((res) =>{
          this.areaList = res.data.data.areas
          this.areaData = res.data.data.areas[0]
          this.fetch()
        })
      },
      fetch(){
        this.areaLoading = true
        const option = {
          'current': this.page,
          'areaId': this.areaData.id,
        }
        json.post('/api/web/index/bgRen_article_list', option).then((res) =>{
          this.articlesList = res.data.data.articles
          this.member = res.data.data.member
          this.areaLoading = false
        })
      },
      toArticleFun(item) {
        this.$router.push('/article?articleId=' + item.id)
      },
      nextPageFun(){
        this.page++
        this.areaLoading = true
        const option = {
          'current': this.page,
          'areaId': this.areaData.id
        }
        json.post('/api/web/index/bgRen_article_list', option).then((res) =>{
          let mergedArray= null
          mergedArray = this.articlesList.concat(res.data.data.articles) 
          this.articlesList = mergedArray
          this.areaLoading = false
        })
      },
      countryFun(item){
        this.areaData = item
        this.fetch()
        this.onCountryFun()
      },
      timeToStr(time){
        return timeToStr(time)
      },
      onCountryFun(){
        if(this.countryState){
          this.countryState = false
        }else{
          this.countryState = true
        }
      }
    }
}
</script>
<style scoped>
</style>